import { cloneDeep } from 'lodash'
import { cpf } from 'src/utils/validators/document';
import { siglaParaNomeUF } from '../enums/uf';

export function sortindividuos (individuos) {
  let individuals = []
  // console.log('[INDIVIDUALS-DEBUG] Raw data from API:', JSON.stringify(individuos))
  individuos.map(item => {
    // console.log('[INDIVIDUALS-DEBUG] Item mobilePhone:', item.mobilePhone, '| email:', item.email)

     var primeiroNome = ''
     var segundoNome = ''

    if(item.name != undefined) {
      primeiroNome = item.name.substring(0, item.name.indexOf(' ', 0))
      segundoNome = item.name.replace(primeiroNome, ' ').trim()
    }
    individuals.push({  'label': item.name + '<br> CPF: ' + cpf.format(item.cpf),
                        'idSGH': item.idSGH,
                        'nome': primeiroNome,
                        'segundoNome' : segundoNome,
                        'cpf': item.cpf,
                        'mae' : item.motherName,
                        'pai' : item.fatherName,
                        'raca' : item.race,
                        'naturalityCode' : item.naturalityCode == 0 ? '' : item.naturalityCode,
                        'dataNascimento' : item.birthDate,
                        'telefone' : item.landLinePhone,
                        'queryType' : item.queryType,
                        'sexo' : item.gender === 'M' ? 'MASCULINO' : 'FEMININO',
                        'cep' : item.zipCode,
                        'endereco' : item.address?.trim() || '',
                        'enderecoNumero'  : item.addressNumber,
                        'enderecoComplemento' : item.addressComplement?.trim() || '',
                        'bairro' : item.neighborhood?.trim() || '',
                        'country' : item.country,
                        'cidade' : item.city,
                        'placeofBirth' : item.placeOfBirth,
                        'uf' : siglaParaNomeUF[item.province] || 'item.province',
                        'email' : item.email,
                        'celular' : item.mobilePhone,
                      })
  });
   // console.log('[INDIVIDUALS-DEBUG] Processed individuals:', JSON.stringify(individuals))
  return individuals.sort((a, b) => (a.nome > b.nome) ? 1 : -1)
}
